import React from "react";
import { fmtDate } from "@/lib/constants";
import { ReceiptToggle } from "@/components/testleads/TestReceipt";
import { DestAlertBanner } from "./DestAlertBanner";

function SendRow({ s, firm }) {
  return (
    <li className="px-2 py-1.5 text-[11px]" data-testid={`dest-test-send-${s.id}`}>
      <div className="flex flex-wrap items-center gap-2">
        <span data-testid={`dest-test-send-status-${s.id}`}
          className={`px-1.5 py-0.5 text-[9px] font-bold uppercase tracking-widest text-white ${s.ok ? "bg-emerald-700" : "bg-red-700"}`}>
          {s.ok ? "Worked" : "Failed"}
        </span>
        <span className="font-mono">{fmtDate(s.created_at)}</span>
        <span>response {s.code}</span>
        <span>{s.fields_sent} fields</span>
        {s.sent_by && <span className="text-zinc-500">by {s.sent_by}</span>}
      </div>
      {s.rejected_reason && <div className="mt-0.5 text-red-800">Buyer replied: {s.rejected_reason}</div>}
      <ReceiptToggle attempt={{ ...s, status: s.ok ? "delivered" : "failed", response_code: s.code }}
        firm={firm} testId={`dest-test-send-receipt-${s.id}`} />
    </li>
  );
}

// The last few test sends for one delivery place, newest first.
export function DestinationTestHistory({ destId, history, firm, onChanged }) {
  if (!history) return null;
  const { sends, last_ok_at: lastOk, alert } = history;
  return (
    <div className="mt-2" data-testid={`dest-test-history-${destId}`}>
      {alert && <DestAlertBanner alert={alert} destId={destId} onChanged={onChanged} />}
      <div className="flex flex-wrap items-center gap-2">
        <span className="label-mono">Recent test sends</span>
        <span className={`text-[10px] ${lastOk ? "text-emerald-800" : "text-zinc-500"}`} data-testid={`dest-test-last-ok-${destId}`}>
          {lastOk ? `Last worked ${fmtDate(lastOk)}` : "No test has worked yet"}
        </span>
      </div>
      {sends.length ? (
        <ul className="mt-1 divide-y divide-zinc-200 border border-zinc-300 bg-white">
          {sends.map((s) => <SendRow key={s.id} s={s} firm={firm} />)}
        </ul>
      ) : (
        <div className="mt-1 text-[11px] text-zinc-500" data-testid={`dest-test-history-empty-${destId}`}>No test sends yet.</div>
      )}
    </div>
  );
}
